import {AxiosError, AxiosResponse} from 'axios';
import {useMutation} from 'react-query';
import postCreateCreditOrderTransaction, {
  IPostCreditOrderTransactionPayload,
} from './postCreateCreditOrderTransaction';

const usePostCreateCreditOrderTransaction = (
  handleAfterSuccess?: (response: AxiosResponse<any>) => void,
  handleOnError?: (statusCode: number | null) => void,
) => {
  return useMutation({
    mutationFn: (payload: IPostCreditOrderTransactionPayload) =>
      postCreateCreditOrderTransaction(payload),

    onSuccess: response => {
      handleAfterSuccess?.(response);
    },

    onError: (error: AxiosError<IAxiosErr>) => {
      const status = error.response?.status ?? null;
      handleOnError?.(status);
    },
  });
};

export default usePostCreateCreditOrderTransaction;
